import BaseService from "@/services/BaseService";

export default class ProductFamilyService extends BaseService {
  constructor() {
    super('odoo/product_family');
  }

  findAll() {
    return this.http.get(`${this._serviceName}/`);
  }

  findAllByBenefitId(benefitId) {
    return this.http.get(`${this._serviceName}/benefit/${benefitId}`);
  }
}
